import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavigationHelpComponent from "go-app/components/Navigation/NavigationHelpComponent";
import { ReactComponent as AngelDoubleRight } from "go-core/images/svg/navigation/angle-double-right.svg";
import { NavigationComponentProps } from "../../utils/types";
import NavigationApplicationsComponent from "./NavigationApplicationsComponent";
import { NavigationContext } from "./NavigationContext";
import NavigationProfileComponent from "./NavigationProfileComponent";
import StickyNavigationItems from "./StickyNavigationItems";

const NavigationComponent = (props: NavigationComponentProps) => {
	const [navigationOpen, setNavigationOpen] = useState(window.innerWidth >= 1368);
	useEffect(() => {
		const updateWindowDimensions = () => {
			const newWidth = window.innerWidth;
			setNavigationOpen(newWidth >= 1368);
		};
		window.addEventListener("resize", updateWindowDimensions);
		return () => window.removeEventListener("resize", updateWindowDimensions);
	}, []);

	return (
		<NavigationContext.Provider value={{ isNavigationCollapsed: !navigationOpen }}>
			<div
				className={classNames("navigation", {
					open: navigationOpen,
				})}
				data-testid="main-navigation-container"
			>
				<div className="navigation-header">
					<Link to="/">
						<img className="navigation-logo-open" alt="GoPOS Logo" src={props.logo} />
						<img className="navigation-logo" alt="GoPOS Logo" src={props.logo_small} />
					</Link>
					<button
						className={`navigation-toggle ${navigationOpen ? "" : "active"}`}
						onClick={() => setNavigationOpen(!navigationOpen)}
					>
						<AngelDoubleRight />
					</button>
				</div>
				<div className="navigation-body" data-testid="main-navigation-body">
					{props.children}
				</div>
				<div className="navigation-footer">
					<Nav variant="pills" className={"flex-column"} activeKey="1">
						{props.stickyNavigationItems && (
							<StickyNavigationItems
								stickyNavigationItems={props.stickyNavigationItems}
								navigationOpen={navigationOpen}
							/>
						)}
						<NavigationApplicationsComponent
							apps={props.apps}
							link_show_all={props.apps_link_show_all}
							company_id={props.company_id}
							fetch_installed_apps={props.apps_fetch_installed}
							organization_name={props.organization_name}
							organization={props.organization}
							fetchMenuApplication={props.fetchMenuApplication}
							menuAppConfig={props.menuAppConfig}
							navigationOpen={navigationOpen}
							settingsPermission={props.settingsPermission}
						/>
						<NavigationHelpComponent
							options={props.help_options}
							serviceAccessRouteLink={props.accessServiceRouteLink}
							navigationOpen={navigationOpen}
						/>
					</Nav>
					{props.profile_name && (
						<NavigationProfileComponent
							profile_avatar={props.profile_avatar}
							profile_name={props.profile_name}
							organization_name={props.organization_name}
							navigationOpen={navigationOpen}
						>
							{props.profile_content}
						</NavigationProfileComponent>
					)}
					{navigationOpen && (
						<div className="navigation-watermark">© GoPOS.pl {new Date().getFullYear()}</div>
					)}
				</div>
			</div>
		</NavigationContext.Provider>
	);
};

export default NavigationComponent;
